import React from "react";

import t1 from "../../../../assets/images/testimonials/greenscreen.jpg";
import t2 from "../../../../assets/images/testimonials/greenscreen2.jpg";
import t3 from "../../../../assets/images/testimonials/greenscreen3.jpg";
import t4 from "../../../../assets/images/testimonials/greenscreen4.jpg";
import t5 from "../../../../assets/images/testimonials/greenscreen5.jpg";
import t6 from "../../../../assets/images/testimonials/tweet1.jpg";

import "./TwitterTestimonials.css";

export default function TwitterTestimonials() {
  return (
    <div className="twitter-testimonials">
      <h1 className="twitter-testimonials-header">Testimonials</h1>
      <p className="twitter-testimonials-text">
        Not a believer yet? Don’t just take our word for it, the community is
        winning DAILY. Keep the testimonials flowing our way -- nothing makes us
        happier than seeing your greenscreens!
      </p>

      <div className="twitter-testimonials-screenshots">
        <img
          src={t1}
          className="twitter-testimonials-screenshot"
          alt="Positive tweet about Gup's Corner"
        />
        <img
          src={t2}
          className="twitter-testimonials-screenshot"
          alt="Positive tweet about Gup's Corner"
        />
        <img
          src={t3}
          className="twitter-testimonials-screenshot"
          alt="Positive tweet about Gup's Corner"
        />
        <img
          src={t4}
          className="twitter-testimonials-screenshot"
          alt="Positive tweet about Gup's Corner"
        />
        <img
          src={t5}
          className="twitter-testimonials-screenshot"
          alt="Positive tweet about Gup's Corner"
        />
        <img
          src={t6}
          className="twitter-testimonials-screenshot"
          alt="Positive tweet about Gup's Corner"
        />
      </div>
    </div>
  );
}
